import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import Hotels from './pages/hotels';
import Restaurants from './pages/restaurants';
import Salons from './pages/salons';
import Orders from './pages/orders';
import OrderDetails from './pages/order-info';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="*" element={<Login />} />
      <Route path="/" element={<Login />} />
      <Route path="login" element={<Login />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="hotels" element={<Hotels />} />
      <Route path="restaurants" element={<Restaurants />} />
      <Route path="salons" element={<Salons />} />
      <Route path="order-list" element={<Orders />} />
      <Route path="order-details" element={<OrderDetails />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
